import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'assign-sponsor';

const vFParams = {
  fieldTitle: 'Assign sponsor',
  placeholder: 'Enter email',
  characterLimit: 100,
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  const minCharacters = 3;
  // format regex accepts: uppercase and lowercase letters, ' ' and '-'
  // E.G 'Daniel van-Berzon'
  // const formatRegex = /^[a-zA-Z- ]*$/;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_INPUT);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  const underCharacterMin = commonValidation.textInput.isUnderCharacterMinimum(values[fieldId], minCharacters);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please type in sponsor’s email address' : null);
  errors[INLINE_ERRORS].push((underCharacterMin && !noValue) ? 'Text has too few characters' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);
  /*
    // DMB: format validation removed as sponsor is now an email address
    // Leaving the code here for when they ask for email format validation
    // const invalidCharacters = commonValidation.textInput.hasBadFormat(values[fieldId], formatRegex);
    // Only show the invalid characters error if the text is within valid limits
    // this avoids showing multiple errors.
    // TODO: if multiple errors are fixed visually, always show this error
    const numCharactersWithinRange = !noValue && !underCharacterMin && !overCharacterLimit;
    if (numCharactersWithinRange && invalidCharacters) {
      errors[INLINE_ERRORS].push('Text contains invalid characters');
    }
  */
  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const initialValues = '';

const assignSponsor = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { assignSponsor };
